import { styled } from "@linaria/react";
import PageSection from "components/rui/page-components/PageSection";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const LogoContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  row-gap: 5rem;
`;

const RetailLeaders = () => {
  const logoData = useStaticQuery(graphql`
    query {
      logo1: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/stance-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, quality: 100, height: 41, width: 180)
        }
      }
      logo2: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/goodwill-logo-tall.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, quality: 100, height: 77, width: 60)
        }
      }
      logo3: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/ups-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, quality: 100, height: 35, width: 214)
        }
      }
      logo4: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/brookshires-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, quality: 100, height: 33, width: 201)
        }
      }
      logo5: file(
        relativePath: {
          eq: "components/retail-security-checklist/assets/talkmore-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, quality: 100, height: 48, width: 175)
        }
      }
    }
  `);

  const LOGOS = [
    logoData.logo1,
    logoData.logo2,
    logoData.logo3,
    logoData.logo4,
    logoData.logo5,
  ];
  return (
    <PageSection title={"Trusted by Retail Leaders"}>
      <LogoContainer>
        {LOGOS.map((l) => (
          <GatsbyImage image={getImage(l)} />
        ))}
      </LogoContainer>
    </PageSection>
  );
};

export default RetailLeaders;
